var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('img',{attrs:{"src":require("../assets/carma-logo.png")}}),_c('h1',[_vm._v("Page not found")]),_c('p',[_vm._v(" It seems the page you're looking for isn't available... ")])])
}]

export { render, staticRenderFns }